"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showShareRecommendation = exports.sendRecommendation = exports.saveShareData = exports.resetShareRecommendation = exports.hideShareRecommendation = exports.SHOW_SHARE_RECOMMENDATION = exports.SEND_RECOMMENDATION_SUCCESS = exports.SEND_RECOMMENDATION_FAILURE = exports.SEND_RECOMMENDATION = exports.SAVE_SHARE_DATA = exports.RESET_SHARE_RECOMMENDATION = exports.HIDE_SHARE_RECOMMENDATION = void 0;
const SHOW_SHARE_RECOMMENDATION = 'SHOW_SHARE_RECOMMENDATION';
exports.SHOW_SHARE_RECOMMENDATION = SHOW_SHARE_RECOMMENDATION;
const HIDE_SHARE_RECOMMENDATION = 'HIDE_SHARE_RECOMMENDATION';
exports.HIDE_SHARE_RECOMMENDATION = HIDE_SHARE_RECOMMENDATION;
const SEND_RECOMMENDATION = 'SHARE_RECOMMENDATION';
exports.SEND_RECOMMENDATION = SEND_RECOMMENDATION;
const SEND_RECOMMENDATION_SUCCESS = 'SEND_RECOMMENDATION_SUCCESS';
exports.SEND_RECOMMENDATION_SUCCESS = SEND_RECOMMENDATION_SUCCESS;
const SEND_RECOMMENDATION_FAILURE = 'SEND_RECOMMENDATION_FAILURE';
exports.SEND_RECOMMENDATION_FAILURE = SEND_RECOMMENDATION_FAILURE;
const SAVE_SHARE_DATA = 'SAVE_SHARE_DATA';
exports.SAVE_SHARE_DATA = SAVE_SHARE_DATA;
const RESET_SHARE_RECOMMENDATION = 'RESET_SHARE_RECOMMENDATION';
exports.RESET_SHARE_RECOMMENDATION = RESET_SHARE_RECOMMENDATION;
const sendRecommendation = payload => ({
  type: SEND_RECOMMENDATION,
  payload
});
exports.sendRecommendation = sendRecommendation;
const showShareRecommendation = () => ({
  type: SHOW_SHARE_RECOMMENDATION
});
exports.showShareRecommendation = showShareRecommendation;
const hideShareRecommendation = () => ({
  type: HIDE_SHARE_RECOMMENDATION
});
exports.hideShareRecommendation = hideShareRecommendation;
const saveShareData = payload => ({
  type: SAVE_SHARE_DATA,
  payload
});
exports.saveShareData = saveShareData;
const resetShareRecommendation = () => ({
  type: RESET_SHARE_RECOMMENDATION
});
exports.resetShareRecommendation = resetShareRecommendation;